// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","component":"LogoPicture_component__92ukI","desktop":"LogoPicture_desktop__fQaio","mobile":"LogoPicture_mobile__053Xk"};